export default __webpack_public_path__ + "static/media/line3.5a5b8f4c.svg";